import { action } from 'satcheljs';
import { AccountProviderType, OWAConnectedAccount } from 'owa-accounts-store';
import { addDatapointConfig } from 'owa-analytics-actions';

/**
 * Connect a new account for OWA
 */
export const connectOWAAccount = action(
    'connectAccount',
    (accountProviderType: AccountProviderType) =>
        addDatapointConfig(
            {
                name: 'connectAccount',
                options: {
                    isCore: true,
                },
                customData: {
                    accountProviderType: accountProviderType,
                },
            },
            {
                accountProviderType,
            }
        )
);

/**
 * Disconnect an account for OWA
 */
export const disconnectOWAAccount = action('disconnectAccount', (account: OWAConnectedAccount) =>
    addDatapointConfig(
        {
            name: 'disconnectOWAAccount',
            options: {
                isCore: true,
            },
            customData: {
                accountProviderType: account.accountProviderType,
            },
        },
        {
            account,
        }
    )
);

/**
 * Announces when an attempt to connect a new OWA connected account has failed
 */
export const connectOWAConnectedAccountFailed = action('connectOWAConnectedAccountFailed');

/**
 * Announces when an attempt to disconnect a new OWA connected account has failed
 */
export const disconnectOWAConnectedAccountFailed = action(
    'disconnectOWAConnectedAccountFailed',
    (primarySmtpAddress: string) => ({
        primarySmtpAddress,
    })
);

/**
 * Announces when an OWA Connected account has been disconncted
 */
export const connectedAccountDisconnected = action(
    'connectedAccountDisconnected',
    (primarySmtpAddress: string) => ({
        primarySmtpAddress,
    })
);

/**
 * Announces when an OWA Connected account has been connected
 */
export const accountConnected = action(
    'accountConnected',
    (primarySmtpAddress: string, accountProviderType: AccountProviderType) =>
        addDatapointConfig(
            {
                name: 'accountConnected',
                options: {
                    isCore: true,
                },
                customData: {
                    accountProviderType: accountProviderType,
                },
            },
            {
                primarySmtpAddress,
                accountProviderType,
            }
        )
);
